// extracted by mini-css-extract-plugin
export default {"cell":"qWLum","contextMenu":"zI5K4"};